import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type {
  Error,
  GetRunsResponse,
  GetTestResultsParams
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  onError?: (error: Error) => void
  onSuccess?: (data: GetRunsResponse) => void
  params?: GetTestResultsParams
  children?: (data: GetRunsResponse) => ReactElement
}

const GetAiRunsRequest = ({
  onError,
  onSuccess,
  params,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/runs`

  const { requestParams } = useGetParamsWithSpaceId<GetTestResultsParams | undefined>(params)

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={requestParams}
      url={url}
    />
  )
}

export default GetAiRunsRequest
